import type { WeeklyReportDay } from '@/lib/apiClient';

/**
 * A day's site photos as the Weekly Report tab shows them: the draft's daily
 * logs, and the filed report where its Word file had that day's photos.
 * Styled by WeeklyReportTab's `wr-photo*` classes, which are mounted with it.
 */
export default function ReportPhotoGrid({ day, thumbs, settled }: {
  day: WeeklyReportDay;
  thumbs: Record<string, string>;
  settled: (u: string) => boolean;
}) {
  // Keyed by post and position: the same file can be posted twice on one day.
  const photos = day.photoPosts.flatMap((p) => p.photos.map((ph, i) => ({ ...ph, key: `${p.id}-${i}`, caption: p.caption, author: p.author })));
  if (!photos.length) return null;
  return (
    <div className="wr-photos">
      {photos.map((ph) => {
        const caption = [ph.caption, ph.author].filter(Boolean).join(' — ');
        return (
          <figure key={ph.key} className="wr-photo-fig">
            <a href={ph.webUrl} target="_blank" rel="noopener noreferrer" title={caption || ph.fileName || 'Photo'}>
              {thumbs[ph.webUrl]
                ? <img className="wr-photo" src={thumbs[ph.webUrl]} alt={caption || ph.fileName || 'Site photo'} loading="lazy" />
                : <span className="wr-photo-ph">{settled(ph.webUrl) ? (ph.fileName ?? 'Photo') : 'Loading…'}</span>}
            </a>
            {caption && <figcaption className="wr-photo-cap">{caption}</figcaption>}
          </figure>
        );
      })}
    </div>
  );
}
